/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Select from "@mui/material/Select";
import ListItemButton from "@mui/material/ListItemButton";
import { Link } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

export default function Sidebar(props) {
  const [selectedPortfolio, setSelectedPortfolio] = useState("");
  const idsData = useSelector((state) => state.idsDetails.ids);

  useEffect(() => {
    // Check if there's a stored portfolio in session storage
    const storedPortfolio = sessionStorage.getItem("portfolioId");

    if (props.selectedPortfolio) {
      // If parent provides a selected portfolio, use it and store it
      setSelectedPortfolio(props.selectedPortfolio);
      sessionStorage.setItem("portfolioId", props.selectedPortfolio);
    } else if (storedPortfolio && idsData.includes(storedPortfolio)) {
      // Use stored portfolio if it exists and is valid
      setSelectedPortfolio(storedPortfolio);
      if (props.sendDataToParent) {
        props.sendDataToParent(storedPortfolio);
      }
    } else if (selectedPortfolio === "" && idsData.length > 0) {
      // Default behavior - select first portfolio and store it
      setSelectedPortfolio(idsData[0]);
      sessionStorage.setItem("portfolioId", idsData[0]);
      if (props.sendDataToParent) {
        props.sendDataToParent(idsData[0]);
      }
    }
  }, [props.selectedPortfolio, idsData, selectedPortfolio, props]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelectedPortfolio(newValue);
    sessionStorage.setItem("portfolioId", newValue);
    if (props.sendDataToParent) {
      props.sendDataToParent(newValue);
    }
  };

  return (
    <Box sx={{ width: "20%", marginLeft: "96px" }}>
      <Box>
        <p className="portfolio-label-text">
          <Typography variant="subtitle2" gutterBottom>
            PORTFOLIO
          </Typography>
        </p>
        <FormControl fullWidth>
          <Select value={selectedPortfolio} onChange={handleChange}>
            {idsData && idsData.length > 0 ? (
              idsData.map((id) => (
                <MenuItem key={id} value={id}>
                  {id}
                </MenuItem>
              ))
            ) : (
              <MenuItem>Loading...</MenuItem>
            )}
          </Select>
        </FormControl>
        <List sx={{ marginTop: "2%" }}>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/oem-admin/settings"
              selected={props.page === "portfolios"}
            >

              <ListItemText primary="Portfolios" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/oem-admin/closed-beta"
              selected={props.page === "closed-beta"}
            >
             
              <ListItemText primary="Closed Beta" />
            </ListItemButton>
          </ListItem>
          {sessionStorage.getItem("idpLogin") !== "true" && (
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/ui/oem-admin/categories"
                selected={props.page === "categories"}
              >
                <ListItemText primary="Categories" />
              </ListItemButton>
            </ListItem>
          )}
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/oem-admin/recommended-apps"
              selected={props.page === "recommended-apps"}
            >
              <ListItemText primary="Recommended Apps" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/oem-admin/make-model-year"
              selected={props.page === "make-model-year"}
            >
              <ListItemText primary="Make Model Year" />
            </ListItemButton>
          </ListItem>
           <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/welcome-wizard"
              selected={props.page === "Welcome wizard"}
            >
              <ListItemText primary="Welcome Wizard" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/oem-admin/notifications"
              selected={props.page === "notifications"}
            >
              <ListItemText primary="Notifications" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/oem-admin/flex-metadata"
              selected={props.page === "flex-metadata"}
            >
              <ListItemText primary="Flex Metadata" />
              </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/ui/oem-admin/settings/dsa-complaint-url"
              selected={props.page === "DSA Complaint URL"}
            >
              <ListItemText primary="DSA Complaint URL" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}

Sidebar.propTypes = {
  selectedPortfolio: PropTypes.string,
  sendDataToParent: PropTypes.func,
  page: PropTypes.string,
};
